var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { assertUserTypeOptional } from "healthex-common/checkusertype";
import { UserPermissions, UserType } from "healthex-common/user.dtos";
import { computed } from "mobx";
import { NOT_LOADED } from "../Infra/RemoteData";
export class HealthSystemUIManager {
    constructor(authManager, organizationsManager) {
        this.authManager = authManager;
        this.organizationsManager = organizationsManager;
    }
    get isLive() {
        return this.authManager.organizationIsLive;
    }
    get isHealthSystem() {
        return this.authManager.userType === UserType.HEALTHCARE_ORGANIZATION;
    }
    get isITAdmin() {
        return this.authManager.permissions.includes(UserPermissions.ORG_ADMIN);
    }
    get isResearchAdmin() {
        return this.authManager.permissions.includes(UserPermissions.RESEARCH_ADMIN);
    }
    get isResearcher() {
        return this.authManager.permissions.includes(UserPermissions.RESEARCHER);
    }
    get isProvider() {
        return this.authManager.isProvider;
    }
    get healthSystem() {
        if (!this.isHealthSystem)
            return null;
        if (this.organizationsManager.myOrganization.value === NOT_LOADED)
            return NOT_LOADED;
        return assertUserTypeOptional(this.organizationsManager.myOrganization.value, UserType.HEALTHCARE_ORGANIZATION);
    }
}
__decorate([
    computed
], HealthSystemUIManager.prototype, "isLive", null);
__decorate([
    computed
], HealthSystemUIManager.prototype, "isHealthSystem", null);
__decorate([
    computed
], HealthSystemUIManager.prototype, "isITAdmin", null);
__decorate([
    computed
], HealthSystemUIManager.prototype, "isResearchAdmin", null);
__decorate([
    computed
], HealthSystemUIManager.prototype, "isResearcher", null);
__decorate([
    computed
], HealthSystemUIManager.prototype, "isProvider", null);
__decorate([
    computed
], HealthSystemUIManager.prototype, "healthSystem", null);
